/* eslint-disable max-len */
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

import {Input, Icon} from '@lazarusai/forms-ui-components-test'

import {storePayload} from '../actions/storePayload'
import {sendPrompt} from '../actions/sendPrompt'

import '../styles/ChatInput.css'

function ChatInput(props) {
  const [isComposition, setIsComposition] = useState(false)

  useEffect(() => {
    const textareaEl = document.getElementsByTagName('textarea')[0]
    textareaEl.addEventListener('compositionstart', handleCompositionStart);
    textareaEl.addEventListener('compositionend', handleCompositionEnd);
  }, [])

  function onChangePrompt(e) {
    props.storePayload({
      promptValue: e.target.value,
    })
  }

  function onInputSubmit() {
    props.sendPrompt(props.promptValue, props.selectedModel)
  }

  function keyPress(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (props.promptValue?.length && !isComposition) {
        onInputSubmit()
      }
    }
    // resizeInput()
    return false
  }

  function handleCompositionStart(event) {
    setIsComposition(true)
  }

  function handleCompositionEnd(event) {
    setIsComposition(false)
  }

  return (
    <div
      className='chat-input'
    >
      <Input
        placeholder={'Enter your prompt here...'}
        key={'prompt-input'}
        name='prompt-input'
        id='prompt-input'
        type={2}
        inputType='submit'
        theme={props.theme}
        label='Alfred'
        value={props.promptValue}
        onChange={onChangePrompt}
        onSubmit={onInputSubmit}
        onKeyDown={keyPress}
        style={{margin: '0'}}
        isAutoResizing={true}
        minHeight={36}
        maxHeight={108}
        iconRight={
          <Icon
            icon='paper-plane-outline'
            className={`submit-icon${props.promptValue?.length ? '': '-disabled'}`}
          />
        }
      />
    </div>
  )
}


const mapStateToProps = (state, ownProps) => ({
  isLoading: state.userReducer.isLoading,
  userId: state.userReducer.userId,
  theme: state.userReducer.theme,
  promptValue: state.userReducer.promptValue,
})

export default connect(
    mapStateToProps,
    {storePayload, sendPrompt},
)(ChatInput)
